module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/insurance/insurance.html
// module id = 730
// module chunks = 0